<div class="ro-container">
  @if (message?.repairOrder) {
  <div class="repair-order">
    <div class="repair-order__info">
      <p>
        <b>{{ 'NGX-MESSAGING.REPAIR-ORDER.id' | translate }}</b> {{ message?.repairOrder?.id }}
      </p>
      <p>
        <b>{{ 'NGX-MESSAGING.REPAIR-ORDER.dealer' | translate }}</b> {{ message?.repairOrder?.dealer?.name }}
      </p>
      <p>
        <b>{{ 'NGX-MESSAGING.REPAIR-ORDER.serviceAdvisor' | translate }}</b>
        {{ message?.repairOrder?.owner?.firstName }}
      </p>
      <p>
        <b>{{ 'NGX-MESSAGING.REPAIR-ORDER.technician' | translate }}</b>
        {{ message?.repairOrder?.technician?.emailAddress }}
      </p>
    </div>

    <div class="repair-order__contact">
      <p>
        <b>{{ 'NGX-MESSAGING.REPAIR-ORDER.date' | translate }}</b>
        {{ $safeNavigationMigration(message?.repairOrder?.createDate) | date }}
      </p>
      <p>
        <b>{{ 'NGX-MESSAGING.REPAIR-ORDER.phone' | translate }}</b> {{ message?.repairOrder?.customer?.mobileNumber }}
      </p>
      <p>
        <b>{{ 'NGX-MESSAGING.REPAIR-ORDER.email' | translate }}</b> {{ message?.repairOrder?.customer?.email }}
      </p>
    </div>
  </div>
  } @if (message?.repairOrder?.video) {
  <video
    controls
    [src]="$safeNavigationMigration(message?.repairOrder?.video)"
    width="100%"
    class="repair-order__video"></video>
  } @if (error()) {
  {{ 'NGX-MESSAGING.REPAIR-ORDER.dataNotFound' | translate }}
  }
</div>
